(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nigellio-pdp"] && !Shopify.designMode) return;
  try {
    
/* ==========================================================================
   Nigellio PDP – portiert aus script.js der Vorlage.
   Alle Blöcke sind optional: fehlt ein Element, überspringt die Funktion es.
   ========================================================================== */
(function () {
  "use strict";

  var root = document.querySelector("pdp-product");
  if (!root) return;
  var cfg = readJson(root, "[data-pdp-config]") || {};

  function readJson(scope, selector) {
    var node = (scope || document).querySelector(selector);
    if (!node) return null;
    try { return JSON.parse(node.textContent); }
    catch (e) { console.warn("[pdp] JSON fehlerhaft:", selector, e); return null; }
  }
  function $(sel, scope) { return (scope || document).querySelector(sel); }
  function $all(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }
  function on(el, type, fn) { if (el) el.addEventListener(type, fn); }
  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c];
    });
  }
  function setText(sel, value) {
    var el = $(sel);
    if (el) el.textContent = value;
  }

  var money = (function () {
    var fmt;
    try {
      fmt = new Intl.NumberFormat(cfg.locale || "de-DE", {
        style: "currency", currency: cfg.currency || "EUR"
      });
    } catch (e) {
      fmt = { format: function (n) { return n.toFixed(2) + " €"; } };
    }
    return function (cents) { return fmt.format((cents || 0) / 100); };
  })();

  /* ------------------------------- galerie -------------------------------- */

  var gallery = cfg.gallery || [];
  var galleryIndex = 0;
  var stageImg = $("#stage-img");
  var scrim = $("#stage-scrim");
  var captionEl = $("#stage-caption");
  var railEl = $("#stage-rail");

  function renderGallery() {
    if (!stageImg || !gallery.length) return;
    var item = gallery[galleryIndex];
    stageImg.src = item.src;
    stageImg.srcset = "";
    stageImg.alt = item.alt || "";
    stageImg.className = "stage-img" + (item.fit === "contain" ? " contain" : "");

    if (captionEl && scrim && railEl) {
      if (item.caption) {
        scrim.hidden = false;
        captionEl.hidden = false;
        captionEl.querySelector(".eyebrow").textContent = item.caption.eyebrow || "";
        captionEl.querySelector(".title").textContent = item.caption.title || "";
        if (item.caption.rail) {
          railEl.hidden = false;
          railEl.querySelector(".label").textContent = item.caption.rail;
        } else {
          railEl.hidden = true;
        }
      } else {
        scrim.hidden = true;
        captionEl.hidden = true;
        railEl.hidden = true;
      }
    }

    $all("#thumbs .thumb").forEach(function (btn) {
      btn.setAttribute("aria-current", String(Number(btn.dataset.index) === galleryIndex));
    });
  }

  function goImage(dir) {
    if (!gallery.length) return;
    galleryIndex = (galleryIndex + dir + gallery.length) % gallery.length;
    renderGallery();
  }

  on($("#prev-img"), "click", function () { goImage(-1); });
  on($("#next-img"), "click", function () { goImage(1); });
  $all("#thumbs .thumb").forEach(function (btn) {
    btn.addEventListener("click", function () {
      galleryIndex = Number(btn.dataset.index);
      renderGallery();
    });
  });

  var stage = $("#stage");
  if (stage) {
    var touchX = null;
    stage.addEventListener("touchstart", function (e) { touchX = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener("touchend", function (e) {
      if (touchX === null) return;
      var dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) goImage(dx < 0 ? 1 : -1);
      touchX = null;
    });
  }

  var lightbox = $("#lightbox");
  var lightboxImg = $("#lightbox-img");
  function openLightbox() {
    if (!lightbox || !gallery.length) return;
    var item = gallery[galleryIndex];
    lightboxImg.src = item.full || item.src;
    lightboxImg.alt = item.alt || "";
    lightbox.dataset.open = "true";
  }
  function closeLightbox() { if (lightbox) lightbox.dataset.open = "false"; }
  on($("#zoom-open"), "click", openLightbox);
  on($("#zoom-close"), "click", closeLightbox);
  if (lightbox) {
    lightbox.addEventListener("click", function (e) { if (e.target !== lightboxImg) closeLightbox(); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeLightbox(); });
  }

  /* ----------------------------- kaufpanel -------------------------------- */

  var variants = cfg.variants || [];
  var tiers = (cfg.tiers || []).slice().sort(function (a, b) { return b.minQty - a.minQty; });
  var state = { quantity: 1, variant: findVariant(cfg.currentVariantId) };

  function findVariant(id) {
    for (var i = 0; i < variants.length; i++) if (variants[i].id === id) return variants[i];
    return variants[0] || null;
  }

  function selectedOptionValues() {
    var values = (state.variant && state.variant.options.slice()) || [];
    $all(".size-pills").forEach(function (group) {
      var index = Number(group.dataset.optionIndex || 0);
      var active = group.querySelector('.size-pill[aria-pressed="true"]');
      if (active) values[index] = active.dataset.value;
    });
    return values;
  }

  function matchVariant(values) {
    for (var i = 0; i < variants.length; i++) {
      var ok = true;
      for (var j = 0; j < values.length; j++) {
        if (variants[i].options[j] !== values[j]) { ok = false; break; }
      }
      if (ok) return variants[i];
    }
    return null;
  }

  /* "250 ml" → 250, "1,5 L" → 1500 */
  function volumeMl(title) {
    var m = String(title).match(/([\d.,]+)\s*(ml|l)\b/i);
    if (!m) return 0;
    var n = parseFloat(m[1].replace(",", "."));
    return m[2].toLowerCase() === "l" ? n * 1000 : n;
  }

  function tierPercent(qty) {
    for (var i = 0; i < tiers.length; i++) {
      if (qty >= tiers[i].minQty) return tiers[i].percent;
    }
    return 0;
  }

  function tierHint(qty) {
    if (!tiers.length) return "";
    var active = tierPercent(qty);
    if (active > 0) return "−" + active + "% Mengenrabatt aktiv";
    return tiers.slice().reverse().map(function (t) {
      return "ab " + t.minQty + " Stk. −" + t.percent + "%";
    }).join(" · ");
  }

  function totals() {
    var v = state.variant;
    if (!v) return null;
    var pct = tierPercent(state.quantity);
    var original = v.price * state.quantity;
    var total = Math.round(original * (1 - pct / 100));
    return {
      variant: v, pct: pct, original: original, total: total,
      savings: original - total,
      shippingFree: cfg.shipping && total >= cfg.shipping.freeFrom
    };
  }

  function renderPurchase() {
    var t = totals();
    if (!t) return;
    var v = t.variant;

    $all(".size-pills").forEach(function (group) {
      var index = Number(group.dataset.optionIndex || 0);
      $all(".size-pill", group).forEach(function (btn) {
        btn.setAttribute("aria-pressed", String(btn.dataset.value === v.options[index]));
      });
    });

    var ml = volumeMl(v.options[cfg.sizeOptionIndex || 0] || v.title);
    var perLiter = ml ? Math.round(v.price / (ml / 1000)) : 0;
    setText("#price-per-liter", perLiter ? money(perLiter) + "/L" : "");
    setText("#per-liter-meta", perLiter ? money(perLiter) : "—");

    setText("#qty-value", String(state.quantity));
    var minus = $("#qty-minus"), plus = $("#qty-plus"), qtyInput = $("#qty-input");
    if (minus) minus.disabled = state.quantity <= 1;
    if (plus) plus.disabled = state.quantity >= 10;
    if (qtyInput) qtyInput.value = state.quantity;
    setText("#bundle-hint", tierHint(state.quantity));

    setText("#price-now", money(t.total));
    var was = $("#price-was");
    if (was) {
      was.hidden = t.original <= t.total;
      was.textContent = money(t.original);
    }
    var pill = $("#savings-pill");
    if (pill) {
      pill.hidden = t.savings <= 0;
      pill.textContent = "Du sparst " + money(t.savings) + (t.pct > 0 ? " · −" + t.pct + "%" : "");
    }

    if (cfg.shipping) {
      setText("#shipping-title", t.shippingFree ? "Versandkostenfrei" : "zzgl. " + money(cfg.shipping.cost) + " Versand");
      setText("#shipping-sub", t.shippingFree ? "Innerhalb Deutschlands" : "Versandkostenfrei ab " + money(cfg.shipping.freeFrom));
    }

    setText("#stock-line", v.available ? "Auf Lager" : "Zurzeit nicht verfügbar");
    setText("#sticky-line", state.quantity + " × " + v.title);
    setText("#sticky-total", money(t.total));

    var hidden = $("[data-pdp-variant-id]");
    if (hidden) hidden.value = v.id;

    var addBtn = $("#add-to-cart");
    if (addBtn) addBtn.disabled = !v.available;
    var ctaLabel = $("#cta-label");
    if (ctaLabel && !v.available) ctaLabel.textContent = "Ausverkauft";

    if (v.mediaId) {
      for (var i = 0; i < gallery.length; i++) {
        if (gallery[i].id === v.mediaId && i !== galleryIndex) { galleryIndex = i; renderGallery(); break; }
      }
    }

    if (window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set("variant", v.id);
      window.history.replaceState({}, "", url);
    }
  }

  $all(".size-pill").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var group = btn.closest(".size-pills");
      $all(".size-pill", group).forEach(function (b) { b.setAttribute("aria-pressed", String(b === btn)); });
      var match = matchVariant(selectedOptionValues());
      if (match) state.variant = match;
      renderPurchase();
    });
  });
  on($("#qty-minus"), "click", function () { state.quantity = Math.max(1, state.quantity - 1); renderPurchase(); });
  on($("#qty-plus"), "click", function () { state.quantity = Math.min(10, state.quantity + 1); renderPurchase(); });
  on($("#to-reviews"), "click", function () {
    var el = $("#reviews");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  });

  /* ---------------------------- warenkorb --------------------------------- */

  var cartStatus = "idle";

  function setCtaIcon(id, spinning) {
    var ctaIcon = $("#cta-icon");
    if (!ctaIcon) return;
    ctaIcon.setAttribute("class", "i" + (spinning ? " spin" : ""));
    ctaIcon.innerHTML = '<use href="#' + id + '"/>';
  }

  function addToCart(event) {
    if (event) event.preventDefault();
    var t = totals();
    if (!t || cartStatus === "loading") return;

    var addBtn = $("#add-to-cart");
    var ctaLabel = $("#cta-label");
    cartStatus = "loading";
    if (addBtn) addBtn.disabled = true;
    if (ctaLabel) ctaLabel.textContent = "Wird hinzugefügt …";
    setCtaIcon("i-loader", true);

    postItems([{ id: t.variant.id, quantity: state.quantity }])
      .then(function () {
        cartStatus = "success";
        if (addBtn) addBtn.disabled = false;
        if (ctaLabel) ctaLabel.textContent = "Zum Warenkorb hinzugefügt";
        setCtaIcon("i-check", false);

        var note = $("#added-note"), text = $("#added-text");
        if (text) {
          text.innerHTML = "<b>" + state.quantity + " × " + esc(t.variant.title) +
            "</b> zum Warenkorb hinzugefügt · Gesamt " + money(t.total);
        }
        if (note) note.dataset.show = "true";

        setTimeout(function () {
          cartStatus = "idle";
          if (ctaLabel) ctaLabel.textContent = "In den Warenkorb";
          setCtaIcon("i-cart", false);
        }, 2200);
      })
      .catch(function (error) {
        cartStatus = "idle";
        if (addBtn) addBtn.disabled = false;
        if (ctaLabel) ctaLabel.textContent = error.message || "Nicht verfügbar";
        setCtaIcon("i-cart", false);
      });
  }

   function cartDrawer() {
    return document.querySelector("cart-drawer");
  }

  /* Welche Sections nach dem Hinzufügen neu gerendert werden.
     Dawn liefert die Liste selbst, inkl. Selector "#CartDrawer". */
  function cartSections() {
    var drawer = cartDrawer();
    if (drawer && typeof drawer.getSectionsToRender === "function") {
      return drawer.getSectionsToRender();
    }
    return [
      { id: "cart-drawer", selector: "#CartDrawer" },
      { id: "cart-icon-bubble" }
    ];
  }

  function postItems(items) {
    var sections = cartSections();
    return fetch((cfg.addUrl || "/cart/add") + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: items,
        sections: sections.map(function (s) { return s.id; }),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (result) {
        if (result.status) throw new Error(result.description || result.message);

        var drawer = cartDrawer();
        // War der Warenkorb beim Seitenaufruf leer, hängt "is-empty" am Drawer
        // und blendet Header + Line Items aus – vor dem Rendern entfernen
        if (drawer) drawer.classList.remove("is-empty");
        if (drawer && typeof drawer.renderContents === "function") {
          // Dawn: rendert Drawer + Badge und öffnet den Drawer
          drawer.renderContents(result);
        } else {
          renderCartSections(result.sections, sections);
          if (drawer && typeof drawer.open === "function") drawer.open();
        }

        document.dispatchEvent(new CustomEvent("pdp:added", { detail: result }));
        return result;
      });
  }

  /* Fallback, falls renderContents nicht existiert (anderes Theme / ältere Version) */
  function renderCartSections(html, sections) {
    if (!html) return;
    sections.forEach(function (s) {
      if (!html[s.id]) return;
      var target = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
      if (!target) return;
      var doc = new DOMParser().parseFromString(html[s.id], "text/html");
      var source = s.selector ? doc.querySelector(s.selector) : doc.querySelector(".shopify-section");
      if (source) target.innerHTML = source.innerHTML;
    });
    var drawer = cartDrawer();
    if (drawer) drawer.classList.remove("is-empty");
  }

  var form = root.querySelector("form");
  if (form) form.addEventListener("submit", addToCart);
  on($("#added-continue"), "click", function () {
    var note = $("#added-note");
    if (note) note.dataset.show = "false";
  });

  var anchor = $("#cta-anchor");
  var stickyBar = $("#sticky-bar");
  if (anchor && stickyBar && "IntersectionObserver" in window) {
    new IntersectionObserver(function (entries) {
      stickyBar.dataset.show = String(!entries[0].isIntersecting);
    }, { threshold: 0 }).observe(anchor);
  }

  /* ------------------- häufig zusammen gekauft ---------------------------- */

  var fbtRoot = document.querySelector("pdp-fbt");
  if (fbtRoot) {
    var fbtItems = readJson(fbtRoot, "[data-fbt-items]") || [];
    var fbtDiscount = Number(fbtRoot.dataset.discount || 0);
    var selected = {};
    fbtItems.forEach(function (item, i) { selected[item.key] = item.required || i === 1; });

    var renderFbt = function () {
      var chosen = fbtItems.filter(function (item) { return selected[item.key]; });
      var subtotal = chosen.reduce(function (s, item) { return s + item.price; }, 0);
      var savings = chosen.length >= 2 ? Math.round(subtotal * fbtDiscount / 100) : 0;
      var total = subtotal - savings;
      var pct = subtotal > 0 ? Math.round((savings / subtotal) * 100) : 0;

      $all("[data-item]", fbtRoot).forEach(function (el) {
        el.dataset.selected = String(!!selected[el.dataset.item]);
      });
      $all("[data-fbt]", fbtRoot).forEach(function (input) {
        input.checked = !!selected[input.dataset.fbt];
      });
      $all("[data-line]", fbtRoot).forEach(function (line) {
        if (selected[line.dataset.line]) line.removeAttribute("data-off");
        else line.dataset.off = "true";
      });

      $all("[data-fbt-total]", fbtRoot).forEach(function (el) { el.textContent = money(total); });
      $all("[data-fbt-was]", fbtRoot).forEach(function (el) {
        el.textContent = money(subtotal);
        el.hidden = savings <= 0;
      });
      $all("[data-fbt-tag]", fbtRoot).forEach(function (el) {
        el.textContent = "−" + pct + "% BUNDLE";
        el.hidden = savings <= 0;
      });
      $all("[data-fbt-count]", fbtRoot).forEach(function (el) { el.textContent = chosen.length + " Artikel gewählt"; });
      $all("[data-fbt-subtotal]", fbtRoot).forEach(function (el) { el.textContent = money(subtotal); });
      $all("[data-fbt-discount]", fbtRoot).forEach(function (el) { el.textContent = "−" + money(savings); });
      $all("[data-fbt-discount-row]", fbtRoot).forEach(function (el) { el.hidden = savings <= 0; });
      $all("[data-fbt-cta]", fbtRoot).forEach(function (el) { el.disabled = chosen.length === 0; });
    };

    $all("[data-fbt]", fbtRoot).forEach(function (input) {
      input.addEventListener("change", function () {
        selected[input.dataset.fbt] = input.checked;
        renderFbt();
      });
    });

    $all("[data-fbt-cta]", fbtRoot).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var chosen = fbtItems.filter(function (item) { return selected[item.key]; });
        if (!chosen.length) return;
        btn.disabled = true;
        postItems(chosen.map(function (item) { return { id: item.id, quantity: 1 }; }))
          .catch(function (error) { console.warn("[pdp] FBT:", error); })
          .then(function () { btn.disabled = false; });
      });
    });

    renderFbt();
  }

  /* --------------------------------- tabs --------------------------------- */

  $all(".tab-btn").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var id = btn.dataset.tab;
      $all(".tab-btn").forEach(function (b) { b.setAttribute("aria-selected", String(b === btn)); });
      $all(".tab-panel").forEach(function (p) { p.hidden = p.dataset.panel !== id; });
    });
  });

  /* ------------------------------ usp strip ------------------------------- */

  var uspScroller = $("#usp-scroller");
  var uspFade = $("#usp-fade");
  if (uspScroller && uspFade) {
    var updateUspFade = function () {
      var atEnd = uspScroller.scrollLeft + uspScroller.clientWidth >= uspScroller.scrollWidth - 4;
      uspFade.dataset.hidden = String(atEnd);
    };
    var uspNext = function () {
      var atEnd = uspScroller.scrollLeft + uspScroller.clientWidth >= uspScroller.scrollWidth - 4;
      var next = atEnd ? 0 : uspScroller.scrollLeft + uspScroller.clientWidth * 0.8;
      uspScroller.scrollTo({ left: next, behavior: "smooth" });
    };
    uspScroller.addEventListener("scroll", updateUspFade, { passive: true });
    window.addEventListener("resize", updateUspFade);
    on($("#usp-next"), "click", uspNext);
    on($("#usp-swipe"), "click", uspNext);
    updateUspFade();
  }

  /* ------------------------------- lieferdatum ---------------------------- */

  function estimatedDelivery() {
    var days = (cfg.shipping && cfg.shipping.deliveryDays) || 3;
    var d = new Date();
    d.setDate(d.getDate() + days);
    var locale = cfg.locale || "de-DE";
    return d.toLocaleDateString(locale, { weekday: "long" }) + ", " +
      d.toLocaleDateString(locale, { day: "numeric", month: "long" });
  }

  /* --------------------------------- init --------------------------------- */

  renderGallery();
  renderPurchase();
  var delivery = estimatedDelivery();
  setText("#delivery-date", delivery);
  $all("[data-fbt-delivery]").forEach(function (el) { el.textContent = delivery; });
})();


  } catch(e) { console.error(e); }
})();
})();
